export default __webpack_public_path__ + "static/media/ShaymaLovelace.ff5ae179.png";